import React from "react";
// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

import Section1 from "../includes/CustomDevelopment/Section1";
import Section2 from "../includes/CustomDevelopment/Section2";
import Section3 from "../includes/CustomDevelopment/Section3";
import Section4 from "../includes/CustomDevelopment/Section4";
import Section5 from "../includes/CustomDevelopment/Section5";
import Section6 from "../includes/CustomDevelopment/Section6";
import Section7 from "../includes/CustomDevelopment/Section7";
// import Section8 from "../includes/CustomDevelopment/Section8";

// form from homepage
import Section9 from "../includes/Home/Section9";

const CustomDevelopment = ({ devUrl }) => {

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Service",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/custom-software-development",
    },
    name: "Custom Software Development Services",
    headline: "Build Scalable Custom Software Solutions for Your Business",
    description:
      "We design and develop custom software applications tailored to your business needs, including web apps, enterprise systems, SaaS platforms, and automation tools.",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    provider: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    areaServed: "Worldwide",
    datePublished: "2026-04-22",
    dateModified: "2026-04-22",
  };

  return (
    <>
      <Helmet>
        <title>Custom Software Development Services</title>

        <meta
          name="description"
          content="We build custom software solutions including web applications, enterprise systems, SaaS platforms, and automation tools tailored to your business needs."
        />

        <link
          rel="canonical"
          href="https://www.exddigital.com/custom-software-development"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Custom Software Development Services | ExD Digital"
        />
        <meta
          property="og:description"
          content="Custom-built software solutions including web apps, enterprise platforms, and automation systems to help your business scale."
        />
        <meta
          property="og:url"
          content="https://www.exddigital.com/custom-software-development"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Custom Software Development Services | ExD Digital"
        />
        <meta
          name="twitter:description"
          content="Build scalable custom software including SaaS platforms, enterprise systems, and automation tools."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <main className="our-ai-main">
        <article className="ai-development">

          <Section1 url={devUrl} />
          <Section2 url={devUrl} />
          <Section3 url={devUrl} />
          <Section4 url={devUrl} />
          <Section5 url={devUrl} />
          <Section6 url={devUrl} />
          <Section7 url={devUrl} />
          <Section9 url={devUrl} />
          {/*<Section8 url={devUrl} /> */}

        </article>
      </main>
    </>
  );
};

export default CustomDevelopment;